import { UsersTable } from '../../components/UnconfirmedUsersTable';

// TODO: Delete this screen and update the Users one to render UsersTable variants
function UnconfirmedUsers() {
  return <UsersTable />;
}

export default UnconfirmedUsers;
